import React, {Component} from 'react';
import Styles from './style.css';
import {langRegister} from "../../services/langRegister";
import {cartRegister} from "../../services/cartRegister"
import {imagesRegister} from "../../services/imagesRegister"
import {quotesRegister} from "../../services/quotesRegister"
import cx from "classnames";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import {BeatLoader} from "react-spinners";
import {dataRegister} from "../../services/dataRegister";
import AnimateHeight from 'react-animate-height';

class BoosterRegionSearch2 extends Component {

    constructor(props) {
        super(props);
        this.state = {
            search: "",
            isLoading: false,
            init_regions: true,
            country_region: {},
            country_regions_count: 0,
            regions: [],
            region_object: {},
            grid: {},
            grid_selected: {},
            regions_selected: [],
            switch: false,
            first: true
        };
    };

    componentDidMount() {
        this.setState({
            country_region: JSON.parse(salesChannelRegister.get('country_region')),
            country_regions_count: JSON.parse(salesChannelRegister.get('country_regions_count')),
            switch: this.props.updateSwitch
        }, () => {
            this._updateData();
        });
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.updateSwitch!==this.props.updateSwitch){
            if(nextProps.updateSwitch && this.state.regions_selected.length > 0){
                /*if(this.state.regions_selected[0].id === this.state.country_region.id){
                    this.state.regions_selected = [];
                    this.setState({regions_selected: this.state.regions_selected}, () => {
                        this._updateRegions(salesChannelRegister.get("market"));
                    })
                }
                */
            }
            this.setState({switch: nextProps.updateSwitch});
        }
    }

    _updateData(){
        let stored_data = cartRegister.get();
        this.setState({
            regions_selected: stored_data.regions ? stored_data.regions : [],
            grid_selected: stored_data.regions_grid ? stored_data.regions_grid : {},
        }, () => {
            this._updateRegions(salesChannelRegister.get("market"));
        });
    }

    _updateRegions(market) {
        this.setState({isLoading: true});
        let regions = this.state.regions_selected.map(function (item) {
            return item.id;
        }).join(",");
        dataRegister.getRegionsExtras(market, regions).then((data) => {
            if (data) {

                let countries = [];
                countries = data.regions.filter((item) => {return item.level === 1});

                if(countries.length === 0){
                    this.setState({country: true, first: false});
                }else if(this.state.regions_selected.length < 1){
                    if(this.state.first){
                        //let uae = {id: 4940, population: 6512706, name: "United Arab Emirates", level: 1, country_code: "AE"};
                        let country_region = JSON.parse(salesChannelRegister.get("country_region"));
                        countries = [];
                        countries.push(country_region);
                        this.setState({regions_selected: countries, first: false}, () => {
                            this._updateRegions(salesChannelRegister.get('market'));
                        });
                    }
                }else{
                    this.setState({first: false});
                }

                let region_object = {};
                for(let i = 0; i < data.regions.length; i++){
                    region_object[data.regions[i].id] = data.regions[i];
                }
                this.setState({region_object: region_object, regions: data.regions}, () => {
                    this.setState({regions: data.regions}, () => {
                        if (data.update.disabled) {
                            for (let m = 0; m < this.state.regions_selected.length; m++) {
                                for (let i = 0; i < data.update.disabled.length; i++) {
                                    if (JSON.stringify(this.state.regions_selected[m].id) === data.update.disabled[i]) {
                                        this.state.regions_selected.splice(m, 1);
                                    }
                                }
                            }
                        }
                        this.setState({
                            regions_selected: this.state.regions_selected,
                            isLoading: false,
                        }, () => {
                            this._updateGrid(data.regions, this.state.regions_selected);
                            this.props.updateSelectedRegions(this.state.regions_selected, this.state.grid_selected, this.state.init_regions);
                            this.setState({init_regions: false});
                        });
                    });
                })
            } else {
                this.setState({error: true});
            }
        }, (error) => {
            this.setState({error: true});
        });
    }

    _updateGrid(regions, selected){

        let object = {};
        let level = 1;

        selected.map((item) => item.selected = true);
        regions = regions.concat(selected);

        //REMOVE FROM GRID_SELECTED IF NOT EXISTING
        for(let key in this.state.grid_selected){
            for(let key_two in this.state.grid_selected[key]){
                for(let key_three in this.state.grid_selected[key][key_two]){
                    let exist = false;
                    for(let i = 0; i < selected.length; i++){
                        if(+selected[i].id === +key_three){
                            console.log("exist");
                            exist = true;
                        }
                    }
                    if(!exist){
                        delete this.state.grid_selected[key][key_two][key_three];
                        if(Object.keys(this.state.grid_selected[key][key_two]).length < 1){
                            delete this.state.grid_selected[key][key_two];
                        }
                    }
                }
            }
        }

        try{
            let first_regions = regions.filter((item) => {return item.level === level});
            for(let i = 0; i < first_regions.length; i++){

                if(this.state.grid_selected[level]){
                    if(this.state.grid_selected[level][first_regions[i].id]){
                        object[first_regions[i].id] = first_regions[i];
                        object[first_regions[i].id].height = 'auto';
                        object[first_regions[i].id].children = {};
                    }else{
                        object[first_regions[i].id] = first_regions[i];
                        object[first_regions[i].id].height = 0;
                        object[first_regions[i].id].children = {};
                    }
                }else{
                    object[first_regions[i].id] = first_regions[i];
                    object[first_regions[i].id].height = 0;
                    object[first_regions[i].id].children = {};
                }
            }
        }catch (e) {
            console.log(e);
        }

        try{
            level = level + 1;
            let second_regions = regions.filter((item) => {return item.level === level});
            for(let i = 0; i < second_regions.length; i++){
                for(let key in object){
                    try {
                        if(object[key].name === second_regions[i].parent){
                            if(this.state.grid_selected[level]){
                                if(this.state.grid_selected[level][second_regions[i].id]){
                                    second_regions[i].height = "auto";
                                }else{
                                    second_regions[i].height = 0;
                                }
                            }else{
                                second_regions[i].height = 0;
                            }
                            second_regions[i].children = {};
                            object[key].children[second_regions[i].id] = second_regions[i];
                        }
                    }catch (e) {}
                }
            }
        }catch (e) {}

        this.setState({grid: object}, () => {
            for(let key_one in this.state.grid){
                if(this.state.grid[key_one].height === "auto"){
                    for(let key_second in this.state.grid[key_one].children){
                        if(this.state.grid[key_one].children[key_second].height === "auto"){
                            this._updateLevel(3, key_one, key_second);
                        }
                    }
                }
            }
        });
    }

    _updateLevel(level, key_one, key_two, key_three, key_four){

        let regions = JSON.parse(JSON.stringify(this.state.regions));
        regions = regions.concat(this.state.regions_selected);

        if(level === 2){
            try{
                regions = regions.filter((item) => {return item.level === level});
                for(let i = 0; i < regions.length; i++){
                    for(let key_two in this.state.grid[key_one].children){
                        try {
                            if(this.state.grid[key_one].children[key_two].name === regions[i].parent){

                                if(this.state.grid_selected[level]){
                                    if(this.state.grid_selected[level][regions[i].id]){
                                        regions[i].height = "auto";
                                    }else{
                                        regions[i].height = 0;
                                    }
                                }else{
                                    regions[i].height = 0;
                                }

                                regions[i].children = {};
                                this.state.grid[key_one].children[key_two].children[regions[i].id] = regions[i];
                            }
                        }catch (e) {}
                    }
                }
                this.setState({grid: this.state.grid}, () => {
                    for(let key_one in this.state.grid){
                        if(this.state.grid[key_one].height === "auto"){
                            for(let key_second in this.state.grid[key_one].children){
                                if(this.state.grid[key_one].children[key_second].height === "auto"){
                                    for(let key_third in this.state.grid[key_one].children[key_second].children){
                                        if(this.state.grid[key_one].children[key_second].children[key_third].height === "auto"){
                                            this._updateLevel(4, key_one, key_second, key_third);
                                        }
                                    }
                                }
                            }
                        }
                    }
                });
            }catch (e) {
                console.log(e);
            }
        }

        if(level === 3){
            try{
                regions = regions.filter((item) => {return item.level === level});
                for(let i = 0; i < regions.length; i++){
                    for(let key_two in this.state.grid[key_one].children){
                        try {
                            if(this.state.grid[key_one].children[key_two].name === regions[i].parent){

                                if(this.state.grid_selected[level]){
                                    if(this.state.grid_selected[level][regions[i].id]){
                                        regions[i].height = "auto";
                                    }else{
                                        regions[i].height = 0;
                                    }
                                }else{
                                    regions[i].height = 0;
                                }

                                regions[i].children = {};
                                this.state.grid[key_one].children[key_two].children[regions[i].id] = regions[i];
                            }
                        }catch (e) {}
                    }
                }
                this.setState({grid: this.state.grid}, () => {
                    for(let key_one in this.state.grid){
                        if(this.state.grid[key_one].height === "auto"){
                            for(let key_second in this.state.grid[key_one].children){
                                if(this.state.grid[key_one].children[key_second].height === "auto"){
                                    for(let key_third in this.state.grid[key_one].children[key_second].children){
                                        if(this.state.grid[key_one].children[key_second].children[key_third].height === "auto"){
                                            this._updateLevel(4, key_one, key_second, key_third);
                                        }
                                    }
                                }
                            }
                        }
                    }
                });
            }catch (e) {
                console.log(e);
            }
        }

        if(level === 4){
            try{
                regions = regions.filter((item) => {return item.level === level});
                for(let i = 0; i < regions.length; i++){
                    for(let key_three in this.state.grid[key_one].children[key_two].children){
                        try{
                            if(this.state.grid[key_one].children[key_two].children[key_three].name === regions[i].parent){

                                if(this.state.grid_selected[level]){
                                    if(this.state.grid_selected[level][regions[i].id]){
                                        regions[i].height = "auto";
                                    }else{
                                        regions[i].height = 0;
                                    }
                                }else{
                                    regions[i].height = 0;
                                }

                                regions[i].children = {};
                                this.state.grid[key_one].children[key_two].children[key_three].children[regions[i].id] = regions[i];
                            }
                        }catch (e) {}
                    }
                }
                this.setState({grid: this.state.grid}, () => {
                    for(let key_one in this.state.grid){
                        if(this.state.grid[key_one].height === "auto"){
                            for(let key_second in this.state.grid[key_one].children){
                                if(this.state.grid[key_one].children[key_second].height === "auto"){
                                    for(let key_third in this.state.grid[key_one].children[key_second].children){
                                        if(this.state.grid[key_one].children[key_second].children[key_third].height === "auto"){
                                            for(let key_four in this.state.grid[key_one].children[key_second].children[key_third].children){
                                                if(this.state.grid[key_one].children[key_second].children[key_third].children[key_four].height === "auto"){
                                                    this._updateLevel(5, key_one, key_second, key_third, key_four);
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                });
            }catch (e) {}
        }

        if(level === 5){
            try{
                regions = regions.filter((item) => {return item.level === level});
                for(let i = 0; i < regions.length; i++){
                    for(let key_four in this.state.grid[key_one].children[key_two].children[key_three].children){
                        try{
                            if(this.state.grid[key_one].children[key_two].children[key_three].children[key_four].name === regions[i].parent){

                                if(this.state.grid_selected[level]){
                                    if(this.state.grid_selected[level][regions[i].id]){
                                        regions[i].height = "auto";
                                    }else{
                                        regions[i].height = 0;
                                    }
                                }else{
                                    regions[i].height = 0;
                                }

                                regions[i].children = {};
                                this.state.grid[key_one].children[key_two].children[key_three].children[key_four].children[regions[i].id] = regions[i];
                            }
                        }catch (e) {}
                    }
                }
                this.setState({grid: this.state.grid}, () => {
                    for(let key_one in this.state.grid){
                        if(this.state.grid[key_one].height === "auto"){
                            for(let key_second in this.state.grid[key_one].children){
                                if(this.state.grid[key_one].children[key_second].height === "auto"){
                                    for(let key_third in this.state.grid[key_one].children[key_second].children){
                                        if(this.state.grid[key_one].children[key_second].children[key_third].height === "auto"){
                                            for(let key_four in this.state.grid[key_one].children[key_second].children[key_third].children){
                                                if(this.state.grid[key_one].children[key_second].children[key_third].children[key_four].height === "auto"){
                                                    for(let key_five in this.state.grid[key_one].children[key_second].children[key_third].children[key_four].children){
                                                        if(this.state.grid[key_one].children[key_second].children[key_third].children[key_four].children[key_five].height === "auto"){
                                                            this._updateLevel(6, key_one, key_second, key_third, key_four, key_five);
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                });
            }catch (e) {}
        }

        if(level === 6){
            try{
                regions = regions.filter((item) => {return item.level === level});
                for(let i = 0; i < regions.length; i++){
                    for(let key_five in this.state.grid[key_one].children[key_two].children[key_three].children[key_four].children){
                        try{
                            if(this.state.grid[key_one].children[key_two].children[key_three].children[key_four].children[key_five].name === regions[i].parent){
                                regions[i].height = 0;
                                regions[i].children = {};
                                this.state.grid[key_one].children[key_two].children[key_three].children[key_four].children[key_five].children[regions[i].id] = regions[i];
                            }
                        }catch (e) {}
                    }
                }
                this.setState({grid: this.state.grid}, () => {});
            }catch (e) {}
        }

    }

    _selectCountry() {
        if(this.state.country){
            let new_regions = [];
            for(let key in this.state.grid){
                if(this.state.grid[key].level === 1){
                    let exist = false;
                    for(let i = 0; i < this.state.regions_selected.length; i++){
                        if(this.state.regions_selected[i].id === this.state.grid[key].id){
                            exist = true;
                            break;
                        }
                    }
                    if(!exist){
                        new_regions.push(this.state.grid[key]);
                    }
                }
            }
            this.setState({
                country: false,
                regions_selected: new_regions,
            }, () => {
                this._updateRegions(salesChannelRegister.get("market"));
            });
        }else{
            for(let key in this.state.grid){
                if(this.state.grid[key].level === 1){
                    let exist = false;
                    for(let i = 0; i < this.state.regions_selected.length; i++){
                        if(this.state.regions_selected[i].id === this.state.grid[key].id){
                            exist = true;
                            break;
                        }
                    }
                    if(!exist){
                        delete this.state.grid[key].children;
                        this.state.regions_selected.push(this.state.grid[key]);
                    }
                }
            }
            this.setState({
                country: true,
                regions_selected: this.state.regions_selected,
            }, () => {
                this._updateRegions(salesChannelRegister.get("market"));
            });
        }
    }

    _selectRegion(prop, key, key_two, key_three, key_four, key_five, key_six) {

            if(key){
                if(this.state.grid_selected["1"]){
                    if(this.state.grid_selected["1"][key]){
                        this.state.grid_selected["1"][key][prop.id] = prop.id;
                    }else{
                        this.state.grid_selected["1"][key] = {};
                        this.state.grid_selected["1"][key][prop.id] = prop.id;
                    }
                }else{
                    this.state.grid_selected["1"] = {};
                    this.state.grid_selected["1"][key] = {};
                    this.state.grid_selected["1"][key][prop.id] = prop.id;
                }
            }

            if(key_two){
                if(this.state.grid_selected["2"]){
                    if(this.state.grid_selected["2"][key_two]){
                        this.state.grid_selected["2"][key_two][prop.id] = prop.id;
                    }else{
                        this.state.grid_selected["2"][key_two] = {};
                        this.state.grid_selected["2"][key_two][prop.id] = prop.id;
                    }
                }else{
                    this.state.grid_selected["2"] = {};
                    this.state.grid_selected["2"][key_two] = {};
                    this.state.grid_selected["2"][key_two][prop.id] = prop.id;
                }
            }

            if(key_three){
                if(this.state.grid_selected["3"]){
                    if(this.state.grid_selected["3"][key_three]){
                        this.state.grid_selected["3"][key_three][prop.id] = prop.id;
                    }else{
                        this.state.grid_selected["3"][key_three] = {};
                        this.state.grid_selected["3"][key_three][prop.id] = prop.id;
                    }
                }else{
                    this.state.grid_selected["3"] = {};
                    this.state.grid_selected["3"][key_three] = {};
                    this.state.grid_selected["3"][key_three][prop.id] = prop.id;
                }
            }

            if(key_four){
                if(this.state.grid_selected["4"]){
                    if(this.state.grid_selected["4"][key_four]){
                        this.state.grid_selected["4"][key_four][prop.id] = prop.id;
                    }else{
                        this.state.grid_selected["4"][key_four] = {};
                        this.state.grid_selected["4"][key_four][prop.id] = prop.id;
                    }
                }else{
                    this.state.grid_selected["4"] = {};
                    this.state.grid_selected["4"][key_four] = {};
                    this.state.grid_selected["4"][key_four][prop.id] = prop.id;
                }
            }

            if(key_five){
                if(this.state.grid_selected["5"]){
                    if(this.state.grid_selected["5"][key_five]){
                        this.state.grid_selected["5"][key_five][prop.id] = prop.id;
                    }else{
                        this.state.grid_selected["5"][key_five] = {};
                        this.state.grid_selected["5"][key_five][prop.id] = prop.id;
                    }
                }else{
                    this.state.grid_selected["5"] = {};
                    this.state.grid_selected["5"][key_five] = {};
                    this.state.grid_selected["5"][key_five][prop.id] = prop.id;
                }
            }

        prop.selected = true;
        this.state.regions_selected.push(prop);
        this.setState({
            regions_selected: this.state.regions_selected,
            grid_selected: this.state.grid_selected,
            search: ""
        }, () => {
            console.log(this.state.grid_selected);
            this._updateRegions(salesChannelRegister.get("market"));
        });
    }

    _selectRegionList(prop){
        let keys = [];
        for(let i = prop.level; i > 0; i--){
            keys.push(null);
        }
        let parent = null;
        for(let i = keys.length; i > 0; i--){
            if(parent){
                console.log(parent);
                keys[i] = parent.id;
                if(parent.parent_id){
                    parent = this.state.region_object[parent.parent_id];
                }
            }else{
                keys[i] = prop.id;
                parent = this.state.region_object[prop.parent_id];
            }
        }
        keys.splice(0, 1);
        this._selectRegion(prop, keys[0], keys[1], keys[2], keys[3], keys[4], keys[5]);
    }

    _removeRegion(prop, key, key_two, key_three, key_four, key_five, key_six) {

        if(key_five && this.state.grid_selected["5"]){
            if(this.state.grid_selected["5"][key_five]){
                if(this.state.grid_selected["5"][key_five][prop.id]){
                    delete this.state.grid_selected["5"][key_five][prop.id];
                    if(Object.keys(this.state.grid_selected["5"][key_five]).length < 1){
                        delete this.state.grid_selected["5"][key_five];
                    }
                }
            }
        }

        if(key_four && this.state.grid_selected["4"]){
            if(this.state.grid_selected["4"][key_four]){
                if(this.state.grid_selected["4"][key_four][prop.id]){
                    delete this.state.grid_selected["4"][key_four][prop.id];
                    if(Object.keys(this.state.grid_selected["4"][key_four]).length < 1){
                        delete this.state.grid_selected["4"][key_four];
                    }
                }
            }
        }

        if(key_three && this.state.grid_selected["3"]){
            if(this.state.grid_selected["3"][key_three]){
                if(this.state.grid_selected["3"][key_three][prop.id]){
                    delete this.state.grid_selected["3"][key_three][prop.id];
                    if(Object.keys(this.state.grid_selected["3"][key_three]).length < 1){
                        delete this.state.grid_selected["3"][key_three];
                    }
                }
            }
        }

        if(key_two && this.state.grid_selected["2"]){
            if(this.state.grid_selected["2"][key_two]){
                if(this.state.grid_selected["2"][key_two][prop.id]){
                    delete this.state.grid_selected["2"][key_two][prop.id];
                    if(Object.keys(this.state.grid_selected["2"][key_two]).length < 1){
                        delete this.state.grid_selected["2"][key_two];
                    }
                }
            }
        }

        if(key && this.state.grid_selected["1"]){
            if(this.state.grid_selected["1"][key]){
                if(this.state.grid_selected["1"][key][prop.id]){
                    delete this.state.grid_selected["1"][key][prop.id];
                    if(Object.keys(this.state.grid_selected["1"][key]).length < 1){
                        delete this.state.grid_selected["1"][key];
                    }
                }
            }
        }

        if(this.state.country && prop.level === 1){
            this.state.country = false;
        }

        prop.selected = false;
        this.setState({
            grid_selected: this.state.grid_selected,
            regions_selected: this.state.regions_selected.filter((item) => {
                return item.id !== prop.id
            }),
            country: this.state.country
        }, () => {
            this._updateRegions(salesChannelRegister.get("market"));
        });
    }

    _removeRegionList(prop){

        let level = prop.level;

        for(let key in this.state.grid_selected){
            for(let key_two in this.state.grid_selected[key]){
                if(this.state.grid_selected[key][key_two][prop.id]){
                    delete this.state.grid_selected[key][key_two][prop.id];
                    if(Object.keys(this.state.grid_selected[key][key_two]).length < 1){
                        delete this.state.grid_selected[key][key_two];
                    }
                }
            }
        }

        prop.selected = false;

        if(this.state.country && level === 1){
            this.state.country = false;
        }

        this.setState({
            grid_selected: this.state.grid_selected,
            regions_selected: this.state.regions_selected.filter((item) => {
                return item.id !== prop.id
            }),
            country: this.state.country
        }, () => {
            this._updateRegions(salesChannelRegister.get("market"));
        });

    }

    _renderAllCountriesSelected(item){
        if(this.state.country || this.state.isLoading){
            return false
        }else{
            return true
        }
    }

    _renderGridOrder(item){
        try {
            let array = [];
            for(let key in item){
                array.push({key: key, name: item[key].name});
            }
            array = array.sort(function (a, b) {
                if (a.name < b.name) {
                    return -1;
                }
                if (a.name > b.name) {
                    return 1;
                }
                return 0;
            });
            array = array.map((item) => {return item.key});
            return array;
        }catch (e) {
            return item;
        }
    }

    _renderName(item){
        try {
            if(salesChannelRegister.get('default_language') !== langRegister.lang()){
                return item.internationalname;
            }else{
                return item.name
            }
        }catch (e) {
            return item.name
        }
    }

    _renderText(item) {
        return langRegister.get("region-search", item);
    }

    render() {
        return (
            <div>
                <div className={Styles.inputContainer}>
                    {
                        this.state.isLoading &&
                        <div className={Styles.inputContainerLoader}>
                            <BeatLoader size={15} color={'var(--first-color)'} loading={true}/>
                        </div>
                    }
                    {
                        this.state.switch &&
                        <div className={Styles.checkMarksContainerOuter}>
                            {
                                this._renderGridOrder(this.state.grid).map((key, i) => {
                                    if(true){
                                        return(
                                            <div>
                                                {
                                                    <div className={
                                                        cx(Styles.subTitleSmall,
                                                            {
                                                                [Styles.subTitleSmallFirstMobile]: i === 0,
                                                                [Styles.subTitleSmallLast]: (Object.keys(this.state.grid).length - 1 === i) && (this.state.grid[key].height !== "auto" || Object.keys(this.state.grid[key].children).length < 1),
                                                                [Styles.subTitleSmallLastClosed]: (Object.keys(this.state.grid).length - 1 === i) && (this.state.grid[key].height !== "auto" || Object.keys(this.state.grid[key].children).length < 1)
                                                            })
                                                    }>
                                                        <div className={Styles.checkMarksContainerItemSmall}>
                                                            {
                                                                !this.state.grid[key].selected &&
                                                                <img onClick={() => this._selectRegion(this.state.grid[key], key)}
                                                                     src={require("../../assets/images/checkmark_new.svg")}
                                                                     className={Styles.checkMarksContainerItemIcon}/>
                                                            }
                                                            {
                                                                this.state.grid[key].selected &&
                                                                <img onClick={() => this._removeRegion(this.state.grid[key], key)}
                                                                     src={require("../../assets/images/square_checkmark_active.svg")}
                                                                     className={Styles.checkMarksContainerItemIcon}/>
                                                            }
                                                            <div onClick={() => {
                                                                if(!this.state.grid[key].selected){
                                                                    this.state.grid[key].height = this.state.grid[key].height === 0 ? 'auto' : 0;
                                                                    this.setState({grid: this.state.grid}, () => {
                                                                        this._updateLevel(2, key)
                                                                    });
                                                                }
                                                            }} className={Styles.checkMarksContainerItemText}>
                                                            <span className={Styles.subTitleSmallHeaderTop}>
                                                                {this._renderName(this.state.grid[key])}
                                                            </span>
                                                            </div>
                                                        </div>
                                                        {
                                                            !this.state.grid[key].selected &&
                                                            <div onClick={() => {
                                                                this.state.grid[key].height = this.state.grid[key].height === 0 ? 'auto' : 0;
                                                                this.setState({grid: this.state.grid});
                                                            }} className={Styles.checkMarksContainerItemSmallExpand}>
                                                                {
                                                                    this.state.grid[key].height === "auto" &&
                                                                    <span>–</span>
                                                                }
                                                                {
                                                                    this.state.grid[key].height !== "auto" &&
                                                                    <span>+</span>
                                                                }
                                                            </div>

                                                        }
                                                    </div>
                                                }
                                                {
                                                    <AnimateHeight
                                                        duration={100}
                                                        height={this.state.grid[key].height}
                                                    >
                                                        <div className={Styles.checkMarksContainerOuter}>
                                                            {
                                                                this._renderGridOrder(this.state.grid[key].children).map((key_two, i) => {
                                                                    return (
                                                                        <div>
                                                                            <div className={
                                                                                cx(Styles.subTitleSmallSecondInner,
                                                                                    {
                                                                                        [Styles.subTitleSmallSecondInnerLast]: i === Object.keys(this.state.grid[key].children).length - 1,
                                                                                    })
                                                                            }>
                                                                                <div className={Styles.checkMarksContainerItemSmall}>
                                                                                    {
                                                                                        !this.state.grid[key].children[key_two].selected &&
                                                                                        <img onClick={() => this._selectRegion(this.state.grid[key].children[key_two], key, key_two)}
                                                                                             src={require("../../assets/images/checkmark_new.svg")}
                                                                                             className={Styles.checkMarksContainerItemIcon}/>
                                                                                    }
                                                                                    {
                                                                                        this.state.grid[key].children[key_two].selected &&
                                                                                        <img onClick={() => this._removeRegion(this.state.grid[key].children[key_two], key, key_two)}
                                                                                             src={require("../../assets/images/square_checkmark_active.svg")}
                                                                                             className={Styles.checkMarksContainerItemIcon}/>
                                                                                    }
                                                                                    <div onClick={() => {
                                                                                        if(!this.state.grid[key].children[key_two].selected){
                                                                                            this.state.grid[key].children[key_two].height = this.state.grid[key].children[key_two].height === 0 ? 'auto' : 0;
                                                                                            this.setState({grid: this.state.grid}, () => {
                                                                                                this._updateLevel(3, key, key_two)
                                                                                            });
                                                                                        }
                                                                                    }} className={Styles.checkMarksContainerItemText}>
                                                                                <span className={Styles.subTitleSmallHeader}>
                                                                                    {this._renderName(this.state.grid[key].children[key_two])}
                                                                                </span>
                                                                                    </div>
                                                                                </div>
                                                                                {
                                                                                    !this.state.grid[key].children[key_two].selected &&
                                                                                    <div onClick={() => {
                                                                                        if(!this.state.grid[key].children[key_two].selected){
                                                                                            this.state.grid[key].children[key_two].height = this.state.grid[key].children[key_two].height === 0 ? 'auto' : 0;
                                                                                            this.setState({grid: this.state.grid}, () => {
                                                                                                this._updateLevel(3, key, key_two)
                                                                                            });
                                                                                        }
                                                                                    }} className={Styles.checkMarksContainerItemSmallExpand}>
                                                                                        {
                                                                                            this.state.grid[key].children[key_two].height === "auto" &&
                                                                                            <span>–</span>
                                                                                        }
                                                                                        {
                                                                                            this.state.grid[key].children[key_two].height !== "auto" &&
                                                                                            <span>+</span>
                                                                                        }
                                                                                    </div>

                                                                                }
                                                                            </div>
                                                                            {
                                                                                <AnimateHeight
                                                                                    duration={100}
                                                                                    height={this.state.grid[key].children[key_two].height}
                                                                                >
                                                                                    <div className={Styles.checkMarksContainerOuter}>
                                                                                        {
                                                                                            this._renderGridOrder(this.state.grid[key].children[key_two].children).map((key_three, i) => {
                                                                                                return (
                                                                                                    <div>
                                                                                                        <div className={cx(Styles.subTitleSmallThirdInner)}>
                                                                                                            <div className={Styles.checkMarksContainerItemSmall}>
                                                                                                                {
                                                                                                                    !this.state.grid[key].children[key_two].children[key_three].selected &&
                                                                                                                    <img onClick={() => this._selectRegion(this.state.grid[key].children[key_two].children[key_three], key, key_two, key_three)}
                                                                                                                         src={require("../../assets/images/checkmark_new.svg")}
                                                                                                                         className={Styles.checkMarksContainerItemIcon}/>
                                                                                                                }
                                                                                                                {
                                                                                                                    this.state.grid[key].children[key_two].children[key_three].selected && salesChannelRegister.get('name') === "propertybooster" &&
                                                                                                                    <img onClick={() => this._removeRegion(this.state.grid[key].children[key_two].children[key_three], key, key_two, key_three)}
                                                                                                                         src={require("../../assets/images/square_checkmark_active.svg")}
                                                                                                                         className={Styles.checkMarksContainerItemIcon}/>
                                                                                                                }
                                                                                                                {
                                                                                                                    this.state.grid[key].children[key_two].children[key_three].selected && salesChannelRegister.get('name') === "boostabostad" &&
                                                                                                                    <img onClick={() => this._removeRegion(this.state.grid[key].children[key_two].children[key_three], key, key_two, key_three)}
                                                                                                                         src={require("../../assets/images/square_checkmark_active.svg")}
                                                                                                                         className={Styles.checkMarksContainerItemIcon}/>
                                                                                                                }
                                                                                                                <div onClick={() => {
                                                                                                                    this.state.grid[key].children[key_two].children[key_three].height = this.state.grid[key].children[key_two].children[key_three].height === 0 ? 'auto' : 0;
                                                                                                                    this.setState({grid: this.state.grid}, () => {
                                                                                                                        this._updateLevel(4, key, key_two, key_three)
                                                                                                                    });
                                                                                                                }}  className={Styles.checkMarksContainerItemText}>
                                                                                                                <span className={Styles.subTitleSmallHeader}>
                                                                                                                    {this._renderName(this.state.grid[key].children[key_two].children[key_three])}
                                                                                                                </span>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                            {
                                                                                                                !this.state.grid[key].children[key_two].children[key_three].selected &&
                                                                                                                <div onClick={() => {
                                                                                                                    this.state.grid[key].children[key_two].children[key_three].height = this.state.grid[key].children[key_two].children[key_three].height === 0 ? 'auto' : 0;
                                                                                                                    this.setState({grid: this.state.grid}, () => {
                                                                                                                        this._updateLevel(4, key, key_two, key_three)
                                                                                                                    });
                                                                                                                }} className={Styles.checkMarksContainerItemSmallExpand}>
                                                                                                                    {
                                                                                                                        this.state.grid[key].children[key_two].children[key_three].height === "auto" &&
                                                                                                                        <span>–</span>
                                                                                                                    }
                                                                                                                    {
                                                                                                                        this.state.grid[key].children[key_two].children[key_three].height !== "auto" &&
                                                                                                                        <span>+</span>
                                                                                                                    }
                                                                                                                </div>

                                                                                                            }
                                                                                                        </div>
                                                                                                        {
                                                                                                            <AnimateHeight
                                                                                                                duration={100}
                                                                                                                height={this.state.grid[key].children[key_two].children[key_three].height}
                                                                                                            >
                                                                                                                <div className={Styles.checkMarksContainerOuter}>
                                                                                                                    {
                                                                                                                        this._renderGridOrder(this.state.grid[key].children[key_two].children[key_three].children).map((key_four, i) => {
                                                                                                                            return (
                                                                                                                                <div>
                                                                                                                                    <div className={Styles.subTitleSmallFourthInner}>
                                                                                                                                        <div className={Styles.checkMarksContainerItemSmall}>
                                                                                                                                            {
                                                                                                                                                !this.state.grid[key].children[key_two].children[key_three].children[key_four].selected &&
                                                                                                                                                <img onClick={() => this._selectRegion(this.state.grid[key].children[key_two].children[key_three].children[key_four], key, key_two, key_three, key_four)}
                                                                                                                                                     src={require("../../assets/images/checkmark_new.svg")}
                                                                                                                                                     className={Styles.checkMarksContainerItemIcon}/>
                                                                                                                                            }
                                                                                                                                            {
                                                                                                                                                this.state.grid[key].children[key_two].children[key_three].children[key_four].selected &&
                                                                                                                                                <img onClick={() => this._removeRegion(this.state.grid[key].children[key_two].children[key_three].children[key_four], key, key_two, key_three, key_four)}
                                                                                                                                                     src={require("../../assets/images/square_checkmark_active.svg")}
                                                                                                                                                     className={Styles.checkMarksContainerItemIcon}/>
                                                                                                                                            }
                                                                                                                                            <div onClick={() => {
                                                                                                                                                this.state.grid[key].children[key_two].children[key_three].children[key_four].height = this.state.grid[key].children[key_two].children[key_three].children[key_four].height === 0 ? 'auto' : 0;
                                                                                                                                                this.setState({grid: this.state.grid}, () => {
                                                                                                                                                    this._updateLevel(5, key, key_two, key_three, key_four)
                                                                                                                                                });
                                                                                                                                            }} className={Styles.checkMarksContainerItemText}>
                                                                                                                                            <span className={Styles.subTitleSmallHeader}>
                                                                                                                                                {this._renderName(this.state.grid[key].children[key_two].children[key_three].children[key_four])}
                                                                                                                                            </span>
                                                                                                                                            </div>
                                                                                                                                        </div>
                                                                                                                                        {
                                                                                                                                            !this.state.grid[key].children[key_two].children[key_three].children[key_four].selected &&
                                                                                                                                            <div onClick={() => {
                                                                                                                                                this.state.grid[key].children[key_two].children[key_three].children[key_four].height = this.state.grid[key].children[key_two].children[key_three].children[key_four].height === 0 ? 'auto' : 0;
                                                                                                                                                this.setState({grid: this.state.grid}, () => {
                                                                                                                                                    this._updateLevel(5, key, key_two, key_three, key_four)
                                                                                                                                                });
                                                                                                                                            }} className={Styles.checkMarksContainerItemSmallExpand}>
                                                                                                                                                {
                                                                                                                                                    this.state.grid[key].children[key_two].children[key_three].children[key_four].height === "auto" &&
                                                                                                                                                    <span>–</span>
                                                                                                                                                }
                                                                                                                                                {
                                                                                                                                                    this.state.grid[key].children[key_two].children[key_three].children[key_four].height !== "auto" &&
                                                                                                                                                    <span>+</span>
                                                                                                                                                }
                                                                                                                                            </div>

                                                                                                                                        }
                                                                                                                                    </div>
                                                                                                                                    {
                                                                                                                                        <AnimateHeight
                                                                                                                                            duration={100}
                                                                                                                                            height={this.state.grid[key].children[key_two].children[key_three].children[key_four].height}
                                                                                                                                        >
                                                                                                                                            <div className={Styles.checkMarksContainerOuter}>
                                                                                                                                                {
                                                                                                                                                    this._renderGridOrder(this.state.grid[key].children[key_two].children[key_three].children[key_four].children).map((key_five, i) => {
                                                                                                                                                        return (
                                                                                                                                                            <div>
                                                                                                                                                                <div className={Styles.subTitleSmallFourthInner}>
                                                                                                                                                                    <div className={Styles.checkMarksContainerItemSmall}>
                                                                                                                                                                        {
                                                                                                                                                                            !this.state.grid[key].children[key_two].children[key_three].children[key_four].children[key_five].selected &&
                                                                                                                                                                            <img onClick={() => this._selectRegion(this.state.grid[key].children[key_two].children[key_three].children[key_four].children[key_five], key, key_two, key_three, key_four, key_five)}
                                                                                                                                                                                 src={require("../../assets/images/checkmark_new.svg")}
                                                                                                                                                                                 className={Styles.checkMarksContainerItemIcon}/>
                                                                                                                                                                        }
                                                                                                                                                                        {
                                                                                                                                                                            this.state.grid[key].children[key_two].children[key_three].children[key_four].children[key_five].selected &&
                                                                                                                                                                            <img onClick={() => this._removeRegion(this.state.grid[key].children[key_two].children[key_three].children[key_four].children[key_five], key, key_two, key_three, key_four, key_five)}
                                                                                                                                                                                 src={require("../../assets/images/square_checkmark_active.svg")}
                                                                                                                                                                                 className={Styles.checkMarksContainerItemIcon}/>
                                                                                                                                                                        }
                                                                                                                                                                        <div onClick={() => {
                                                                                                                                                                            this.state.grid[key].children[key_two].children[key_three].children[key_four].children[key_five].height = this.state.grid[key].children[key_two].children[key_three].children[key_four].children[key_five].height === 0 ? 'auto' : 0;
                                                                                                                                                                            this.setState({grid: this.state.grid}, () => {
                                                                                                                                                                                this._updateLevel(6, key, key_two, key_three, key_four, key_five)
                                                                                                                                                                            });
                                                                                                                                                                        }}  className={Styles.checkMarksContainerItemText}>
                                                                                                                                                                        <span className={Styles.subTitleSmallHeader}>
                                                                                                                                                                            {this._renderName(this.state.grid[key].children[key_two].children[key_three].children[key_four].children[key_five])}
                                                                                                                                                                        </span>
                                                                                                                                                                        </div>
                                                                                                                                                                    </div>
                                                                                                                                                                    {
                                                                                                                                                                        !this.state.grid[key].children[key_two].children[key_three].children[key_four].children[key_five].selected &&
                                                                                                                                                                        <div onClick={() => {
                                                                                                                                                                            this.state.grid[key].children[key_two].children[key_three].children[key_four].children[key_five].height = this.state.grid[key].children[key_two].children[key_three].children[key_four].children[key_five].height === 0 ? 'auto' : 0;
                                                                                                                                                                            this.setState({grid: this.state.grid}, () => {
                                                                                                                                                                                this._updateLevel(6, key, key_two, key_three, key_four, key_five)
                                                                                                                                                                            });
                                                                                                                                                                        }} className={Styles.checkMarksContainerItemSmallExpand}>
                                                                                                                                                                            {
                                                                                                                                                                                this.state.grid[key].children[key_two].children[key_three].children[key_four].children[key_five].height === "auto" &&
                                                                                                                                                                                <span>–</span>
                                                                                                                                                                            }
                                                                                                                                                                            {
                                                                                                                                                                                this.state.grid[key].children[key_two].children[key_three].children[key_four].children[key_five].height !== "auto" &&
                                                                                                                                                                                <span>+</span>
                                                                                                                                                                            }
                                                                                                                                                                        </div>

                                                                                                                                                                    }
                                                                                                                                                                </div>
                                                                                                                                                                {
                                                                                                                                                                    <AnimateHeight
                                                                                                                                                                        duration={100}
                                                                                                                                                                        height={this.state.grid[key].children[key_two].children[key_three].children[key_four].children[key_five].height}
                                                                                                                                                                    >
                                                                                                                                                                        <div className={Styles.checkMarksContainerOuter}>
                                                                                                                                                                            {
                                                                                                                                                                                this._renderGridOrder(this.state.grid[key].children[key_two].children[key_three].children[key_four].children[key_five].children).map((key_six, i) => {
                                                                                                                                                                                    return (
                                                                                                                                                                                        <div>
                                                                                                                                                                                            <div className={Styles.subTitleSmallFifthInner}>
                                                                                                                                                                                                <div className={Styles.checkMarksContainerItemSmall}>
                                                                                                                                                                                                    {
                                                                                                                                                                                                        !this.state.grid[key].children[key_two].children[key_three].children[key_four].children[key_five].children[key_six].selected &&
                                                                                                                                                                                                        <img onClick={() => this._selectRegion(this.state.grid[key].children[key_two].children[key_three].children[key_four].children[key_five].children[key_six], key, key_two, key_three, key_four, key_five, key_six)}
                                                                                                                                                                                                             src={require("../../assets/images/checkmark_new.svg")}
                                                                                                                                                                                                             className={Styles.checkMarksContainerItemIcon}/>
                                                                                                                                                                                                    }
                                                                                                                                                                                                    {
                                                                                                                                                                                                        this.state.grid[key].children[key_two].children[key_three].children[key_four].children[key_five].children[key_six].selected &&
                                                                                                                                                                                                        <img onClick={() => this._removeRegion(this.state.grid[key].children[key_two].children[key_three].children[key_four].children[key_five].children[key_six], key, key_two, key_three, key_four, key_five, key_six)}
                                                                                                                                                                                                             src={require("../../assets/images/square_checkmark_active.svg")}
                                                                                                                                                                                                             className={Styles.checkMarksContainerItemIcon}/>
                                                                                                                                                                                                    }
                                                                                                                                                                                                    <div className={Styles.checkMarksContainerItemText}>
                                                                                                                                                                                                    <span className={Styles.subTitleSmallHeader}>
                                                                                                                                                                                                        {this._renderName(this.state.grid[key].children[key_two].children[key_three].children[key_four].children[key_five].children[key_six])}
                                                                                                                                                                                                    </span>
                                                                                                                                                                                                    </div>
                                                                                                                                                                                                </div>
                                                                                                                                                                                            </div>

                                                                                                                                                                                        </div>
                                                                                                                                                                                    )
                                                                                                                                                                                })
                                                                                                                                                                            }
                                                                                                                                                                        </div>
                                                                                                                                                                    </AnimateHeight>
                                                                                                                                                                }
                                                                                                                                                            </div>
                                                                                                                                                        )
                                                                                                                                                    })
                                                                                                                                                }
                                                                                                                                            </div>
                                                                                                                                        </AnimateHeight>
                                                                                                                                    }
                                                                                                                                </div>
                                                                                                                            )
                                                                                                                        })
                                                                                                                    }
                                                                                                                </div>
                                                                                                            </AnimateHeight>
                                                                                                        }
                                                                                                    </div>
                                                                                                )
                                                                                            })
                                                                                        }
                                                                                        {
                                                                                            Object.keys(this.state.grid[key].children[key_two].children).length > 0 && false &&
                                                                                            <div className={Styles.divider}></div>
                                                                                        }
                                                                                    </div>
                                                                                </AnimateHeight>
                                                                            }
                                                                        </div>
                                                                    )
                                                                })
                                                            }
                                                        </div>
                                                    </AnimateHeight>
                                                }
                                            </div>
                                        )
                                    }
                                })
                            }
                        </div>
                    }
                    {
                        !this.state.switch &&
                        <div style={{position: "relative", flex: 1, display: "flex"}}>
                            <input onFocus={() => {
                                this.setState({dropdown: true});
                                if(this.state.country){
                                    this._selectCountry();
                                }
                            }}
                                   onBlur={() => this.setState({dropdown: false})}
                                   value={this.state.search}
                                   onChange={(event) => this.setState({search: event.target.value})}
                                   //placeholder={this._renderText("item_2")}
                                   placeholder={this.state.country? (this._renderText('item_2')):(this._renderText('item_4'))}
                                   className={
                                       cx(Styles.input,
                                           {
                                               [Styles.inputDisabled]: this.state.country
                                           })
                                   }
                            />
                            {
                                this.state.dropdown && this.state.regions.filter((item) => {
                                    return item.name.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1
                                }).length > 0 &&
                                <div className={cx(Styles.inputDropdown, Styles.inputDropdownRegion)}>
                                    {
                                        this.state.regions.filter((item) => {
                                            return item.name.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1
                                        }).sort(function (a, b) {
                                            if (a.name < b.name) {
                                                return -1;
                                            }
                                            if (a.name > b.name) {
                                                return 1;
                                            }
                                            return 0;
                                        }).map((prop, key) => {
                                            return (
                                                <div key={key}
                                                     onMouseDown={() => this._selectRegionList(prop)}
                                                     className={Styles.inputDropdownItem}>
                                                    {prop.name + " (" + prop.parent +  ")"}
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            }
                        </div>
                    }
                    {
                        !this.state.switch &&
                        <div className={Styles.regionCheckMarksContainerItem}>
                            {
                                !this.state.country &&
                                <img onClick={() => this._selectCountry()}
                                     src={require("../../assets/images/square_checkmark_two.svg")}
                                     className={Styles.regionCheckMarksContainerItemIconOther}/>
                            }
                            {
                                !this.state.country &&
                                <img onClick={() => this._selectCountry()}
                                     src={require("../../assets/images/checkmark_new.svg")}
                                     className={Styles.regionCheckMarksContainerItemIconMobile}/>
                            }
                            {
                                this.state.country &&
                                <img
                                    onClick={() => this._selectCountry()}
                                    src={require("../../assets/images/square_checkmark_active.svg")}
                                    className={Styles.regionCheckMarksContainerItemIcon}/>
                            }
                            <div onClick={() => this._selectCountry()} className={Styles.regionCheckMarksContainerItemText}>
                                {
                                    <span>{this._renderText("item_3")}</span>
                                }
                                {
                                    false &&
                                    salesChannelRegister.get("name") === "boostabostad" &&
                                    <span>Hela Sverige</span>
                                }
                            </div>
                        </div>
                    }
                </div>
                {
                    !this.state.switch &&
                    <div className={Styles.regionsContainer}>
                        {
                            this.state.regions_selected &&
                            this.state.regions_selected.filter((item) => {
                                return this._renderAllCountriesSelected(item)
                            }).map((prop, i) => {
                                return (
                                    <div key={i} className={Styles.regionsContainerItem}>
                                        <div className={Styles.regionsContainerItemTitle}>
                                            {prop.name}
                                            {
                                                prop.parent &&
                                                <span
                                                    className={Styles.regionsContainerItemSubtitle}>({prop.parent})</span>
                                            }
                                        </div>
                                        <img onClick={() => this._removeRegionList(prop)}
                                             src={require("../../assets/images/small_cross_white.png")}
                                             className={Styles.regionsContainerItemIcon}
                                        />
                                    </div>
                                )

                            })
                        }
                    </div>
                }
            </div>
        );
    }
}

/*
<div key={i} className={Styles.checkMarksContainerItemSmall}>
                                                                        {
                                                                            !prop.selected &&
                                                                            <img onClick={() => this._selectRegion(prop, key)}
                                                                                 src={require("../../assets/images/checkmark_new.svg")}
                                                                                 className={Styles.checkMarksContainerItemIcon}/>
                                                                        }
                                                                        {
                                                                            prop.selected &&
                                                                            <img onClick={() => this._removeRegion(prop, key)}
                                                                                 src={require("../../assets/images/square_checkmark_active.svg")}
                                                                                 className={Styles.checkMarksContainerItemIcon}/>
                                                                        }
                                                                        <div onClick={() => {
                                                                            if(prop.selected){
                                                                                this._removeRegion(prop, key)
                                                                            }else{
                                                                                this._selectRegion(prop, key)
                                                                            }
                                                                        }} className={Styles.checkMarksContainerItemText}>
                                                                            {prop.name}
                                                                        </div>
                                                                    </div>
 */

export default BoosterRegionSearch2;


// WEBPACK FOOTER //
// ./src/components/booster-region-search-2/component.js